module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-heading items",
    style: (_vm.themeColor)
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "text-large amount"
  }, [_vm._v("\n            " + _vm._s(_vm.total) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-large package-name"
  }, [_vm._v("\n            " + _vm._s(_vm.item.name) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.item.quantity),
      expression: "item.quantity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "quantity",
    attrs: {
      "id": "quantity"
    },
    on: {
      "change": function($event) {
        _vm.item.quantity = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        })[0]
      }
    }
  }, _vm._l((10), function(qty) {
    return _c('option', {
      domProps: {
        "value": qty
      }
    }, [_vm._v(" " + _vm._s(_vm.displayQty(qty)))])
  }))]), _vm._v(" "), (_vm.item.isAddon) ? _c('a', {
    staticClass: "remove-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.remove(_vm.item)
      }
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2804c827!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultipleLineItem.vue
// module id = 74
// module chunks = 0